/**
 * @generated SignedSource<<1970cdd316959746f47cb2d7acad0769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductActionColumn_ProductFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "ProductActionColumn_ProductFragment";
};
export type ProductActionColumn_ProductFragment$key = {
  readonly " $data"?: ProductActionColumn_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductActionColumn_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductActionColumn_ProductFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "cc4bcb4d89cb5e1789ed5278c89d75a4";

export default node;
